import Select from '@ben/orion/deprecated-select';
import { useQuery } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { memo, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { getApprovalFlows } from '../../../api';
import { fieldCannotBeBlankErrorMessage } from '../../shared/constants';

interface ApprovalFlowDropdownProps {
  componentControllerName: string;
  employerId: number;
}

const ApprovalFlowDropdown = ({
  componentControllerName,
  employerId,
}: ApprovalFlowDropdownProps) => {
  const { control } = useFormContext();

  const [searchKey, setSearchKey] = useState('');

  const dropdownQueryKey = 'dropdownOptionsFor-approval-flows';

  const { data: approvalFlows } = useQuery({
    queryKey: [dropdownQueryKey, { searchKey }],
    queryFn: () => getApprovalFlows(employerId, searchKey),
    select: (data) => {
      const incomingResults = data.results.map(
        ({ name, id }: { name: string; id: number }) => ({
          label: name,
          key: id.toString(),
        })
      );
      return incomingResults;
    },
  });

  const handleSearchChange = debounce((search: string) => {
    setSearchKey(search);
  }, 100);

  return (
    <Controller
      key={componentControllerName}
      name={`${componentControllerName}.approvalFlow`}
      control={control}
      rules={{ required: fieldCannotBeBlankErrorMessage }}
      render={({ field, fieldState }) => (
        <Select
          options={approvalFlows || []}
          name="Approval flow"
          onChange={(value) => field.onChange(value)}
          errorMessage={fieldState.error?.message}
          hasError={!!fieldState.error}
          value={
            field.value === undefined || field.value === null
              ? undefined
              : String(field.value)
          }
          showSearch
          onSearchChange={handleSearchChange}
          data-testid="approval-flow-input"
        />
      )}
    />
  );
};

export default memo(ApprovalFlowDropdown);
